export default {
    ignoreLogs: function ignoreLogs() {},
    ignoreAllLogs: function ignoreAllLogs() {}
};
